var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "map map-outdoor mapboxgl-map",
      attrs: { id: "mapOutdoor" },
    },
    [
      !_vm.readOnlyMode
        ? _c(
            "div",
            { staticClass: "absolute bottom-2 right-2 z-10" },
            [
              _c("UiSwitch", {
                staticStyle: {
                  width: "200px",
                  "box-shadow": "var(--shadows-base)",
                },
                attrs: {
                  labelYes: _vm.$t("plans.mapstyles.vecto"),
                  labelNo: _vm.$t("plans.mapstyles.sat"),
                },
                model: {
                  value: _vm.displayMapVecto,
                  callback: function ($$v) {
                    _vm.displayMapVecto = $$v
                  },
                  expression: "displayMapVecto",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "marker marker-ghost",
          staticStyle: {
            width: "50px",
            height: "50px",
            position: "absolute",
            "z-index": "100",
            "pointer-events": "none",
            top: "-50px",
            left: "-50px",
            display: "none",
          },
          attrs: { id: "marker-ghost" },
        },
        [
          _c("img", {
            staticStyle: { width: "50px", height: "50px" },
            attrs: { src: _vm.markerWifi },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "marker-popup",
        staticStyle: {
          position: "absolute",
          "z-index": "100",
          "pointer-events": "none",
          top: "-50px",
          left: "-50px",
          display: "none",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }